import styled from 'styled-components';
import { propSwitch } from '../../../../common/util/propSwitch';

export const OptionList = styled.div<{ row?: boolean }>`
  display: flex;
  flex-flow: ${propSwitch('row', `row wrap`, `column nowrap`)};
  margin: ${props => props.theme.enumFilter?.optionGroupMargin};
`;
